var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchNear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M43.46,27.65a8.89,8.89,0,0,0-14.61,0,8.9,8.9,0,0,0-1,8.19A6.91,6.91,0,0,0,29.11,38l6.46,7.59a.78.78,0,0,0,.59.27.76.76,0,0,0,.58-.27L43.2,38a6.83,6.83,0,0,0,1.29-2.13A8.87,8.87,0,0,0,43.46,27.65Zm-.41,7.66A5.65,5.65,0,0,1,42,37h0l-5.87,6.9L30.28,37a5.41,5.41,0,0,1-1-1.67,7.37,7.37,0,0,1,.86-6.77,7.34,7.34,0,0,1,12.07,0A7.33,7.33,0,0,1,43.05,35.31Z",
    transform: "translate(-24 -22.83)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M36.16,28.39a4.31,4.31,0,1,0,4.31,4.31A4.32,4.32,0,0,0,36.16,28.39Zm0,7.08a2.77,2.77,0,1,1,2.77-2.77A2.77,2.77,0,0,1,36.16,35.47Z",
    transform: "translate(-24 -22.83)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNear);
export default __webpack_public_path__ + "static/media/search-near.3fc10aad3a3876b7f25ef22c3c695f6b.svg";
export { ForwardRef as ReactComponent };